const translationEs = {
    comu: {
        si: "Si",
        no: "No",
        resetFiltre: "Borrar filtro",
        detall: "Ver el detalle",
        tancar: "Cerrar",
        deselecionar: "Deseleccionar todo",
        noRegistres: 'No hay registros',
        refrescar: 'Refrescar',
    },
    page: {
        notFound: "No encontrado",
    },
    clients: {
        title: "Clientes",
        create: "Crear cliente",
        update: "Modificar cliente",
    },
    zones: {
        title: "Zonas",
        create: "Crear zona",
        update: "Modificar zona",
    },
    zonesUser: {
        title: "Zonas de usuario",
        create: "Crear zona de usuario",
        update: "Modificar zona de usuario",
    },
    reserves: {
        title: "Reservas",
        titleDetall: "Reserva",
        create: "Crear reserva",
        update: "Modificar reserva",
        readOnly: "Detalle de reserva",
        totals: {
            title: "Totales",
            adults: "Adultos",
            infants: "Niños",
            bebes: "Bebes",
            efectiu: "Efectivo",
            targeta: "Tarjeta",
            reserves: "Reservas",
            total: "Total",
        },
        exportarA3: "Descargar export A3",
        reservaManual: "Esta reserva ha sido modificada manualmente",
        liniaManual: "Alguna de las líneas de esta reserva han sido modificadas manualmente",
        reservaLiniaManual: "Tanto esta reserva como alguna de sus líneas han sido modificadas manualmente",
        altres: 'Otros',
        campsEveret: 'Campos Everet',
        seleccionarTot: 'Seleccionar todas las reservas',
    },
    recursos: {
        title: "Recursos",
        create: "Crear recurso",
        update: "Modificar recurso",
    },
    embarcacions: {
        title: "Embarcaciones",
        create: "Crear embarcación",
        update: "Modificar embarcación",
    },
    reservesDescompte: {
        title: "Descuentos de reserva",
        create: "Crear descuentos de reserva",
        update: "Modificar descuentos de reserva",
    },
    reservesLinia: {
        title: "Linias de reserva",
        create: "Crear linias de reserva",
        update: "Modificar linias de reserva",
    },
    requisitsRecurs: {
        title: "Requisitos de recursos",
        create: "Crear requisitos de recursos",
        update: "Modificar requisitos de recursos",
    },
    requerimentsRecurs: {
        title: "Requerimientos de recursos",
        create: "Crear requerimiento de recursos",
        update: "Modificar requerimiento de recursos",
    },
    users: {
        title: "Usuarios",
        create: "Crear usuario",
        update: "Modificar usuario",
        password: {
            title: "Cambiar contraseña",
            caption: "Rellenar sólo si se quiere modificar la contraseña del usuario",
        },
    },
    productes: {
        title: "Productos",
        create: "Crear producto",
        update: "Modificar producto",
    },
    agendesProducte: {
        title: "Disponibilidad del producto",
        create: "Crear disponibilidad del producto",
        update: "Modificar disponibilidad del producto",
        readOnly: "Detalle de disponibilidad del producto",
        tab: {
            taula: 'Lista',
            calendari: 'Calendario',
        },
        actions: {
            planificar: {
                title: 'Planificar',
                tabForm: 'Datos generales',
            },
            seleccionar: 'Seleccionar todas las disponibilidades',
        },
        detall: {
            title: 'Ver detalle',
        },
        calendari: {
            switchProductes: "Filtrar por todos los productos",
        },
    },
    parametres: {
        title: 'Parámetros',
        titleMobil: 'Precio Cuevas para la aplicación móvil',
        titleComptabilitat: 'Parámetros para contabilidad',
        titleCreuers: 'Paràmetres de Creuers',
        titleVerifactu: 'Parámetros para Verifactu',
        titleRegimsIva: 'Parámetros para Régimenes IVA'
    },
    informes: {
        title: 'Informes por zona y vendedor',
        create: 'Crear informe',
        update: 'Modificar informe',
        totals: {
            efectiu: 'Efectivo',
            targeta: 'Tarjeta',
            tiquets: 'Tiques',
            coves: 'Cuevas',
            total: 'Importe total',
            resultats: 'Resultados',
        },
    },
    informesTripulacio: {
        title: 'Informe de tripulación por recurso y/o embarcación',
        patrons: 'Patrones',
        mecanics: 'Mecánicos',
        tripulancio: 'Tripulación',
        marinerFotos: 'Marinero fotos',
        marinerBar: 'Marinero bar',
        tots: 'Todos los roles',
        columnes: {
            nom: 'Nombre',
            dies: 'Días',
            percentatge: 'Porcentaje',
        },
    },
    informesEmbarcacio: {
        title: 'Informe de tripulación por embarcación',
        patrons: 'Patrones',
        mecanics: 'Mecánicos',
        tripulancio: 'Tripulación',
        columnes: {
            codi: 'Codigo',
            nom: 'Nombre',
            dies: 'Días',
            percentatge: 'Porcentaje',
        },
    },
    grafics: {
        title: 'Uso de recursos',
        ocupacio: 'Ocupación por recurso y hora',
        alert: 'No hay una fecha seleccionada, por favor selecciona una fecha.',
        refrescar: 'Refrescar',
    },
    proveidor: {
        title: 'Proveedor',
        create: 'Crear proveedor',
        update: 'Modificar proveedor',
    },
    centreCost: {
        title: 'Centro de costes',
        create: 'Crear centro de coste',
        update: 'Modificar centro de coste',
    },
    rutes: {
        title: 'Rutas planificadas',
        create: 'Crear ruta planificada',
        update: 'Modificar ruta planificada',
        rutesMassives: 'Creación de rutas a partir de disponibilidades',
        resultatsRutes: 'Resultados de la creación de rutas a partir de disponibilidades',
        tabs: {
            punt: {
                title:'Puntos de la ruta',
                create: 'Crear punto',
                update: 'Modificar punto',
                observacions: 'Observaciones',
            },
            usuari: {
                title: 'Tripulación',
                create: 'Crear tripulante',
                update: 'Modificar tripulante',
            },
            incidencia: {
                title: 'Incidencias',
                create: 'Crear incidencia',
                update: 'Modificar incidencia',
            },
        },
    },
    series: {
        title: 'Series',
        create: 'Crear una serie',
        update: 'Modificar la serie',
    },
    terminals: {
        title: 'Terminales',
        create: 'Crear un terminal',
        update: 'Modificar un terminal',
    },
    tripulants: {
        title: 'Tripulantes',
        create: 'Crear un tripulante',
        update: 'Modificar un tripulante',
    },
    tripulantRuta: {
        title: 'Ruta-Tripulante',
        create: 'Crear Ruta-Tripulante',
        update: 'Modificar Ruta-Tripulante',
    },
    articles: {
        title: 'Artículos',
        create: 'Crear artículo',
        update: 'Modificar artículo',
    },
    categories: {
        title: 'Categorías',
        create: 'Crear categoría',
        update: 'Modificar categoría',
    },
    articleExistencies: {
        title: 'Existencias',
        create: 'Crear existencia',
        update: 'Modificar existencia',
        action: {
            operacioCompra: {
                quantitat: 'Cantidad',
                quantitatPlaceHolder: 'Cantidad de artículos comprados',
            },
            operacioInventari: {
                quantitat: 'Cantidad',
                quantitatPlaceHolder: 'Cantidad de artículos',
            },
            operacioTraspas: {
                quantitat: 'Cantidad',
                quantitatPlaceHolder: 'Cantidad de artículos a traspasar',
            },
        },
    },
    everet: {
        title: 'Everet',
        versio: 'Versión',
        estat: 'Estado',
        anarEveret: 'Ir a Everet',
        actiu: 'Activo',
        inactiu: 'Inactivo',
    },
    versio: {
        title: 'Versión',
        subTitle: 'Información de la versión',
        nom: 'Nombre del proyecto',
        versio: 'Versión',
        data: 'Fecha',
    },
    operacio: {
        title: 'Operaciones',
        titleDetall: 'Operación',
        create: 'Crear operación',
        update: 'Modificar operación',
        readOnly: 'Detalle de operación',
        operacioManual: "Esta operación ha sido modificada manualmente",
        liniaManual: "Alguna de las líneas de esta operación han sido modificadas manualmente",
        operacioLiniaManual: "Tanto esta operación como alguna de sus líneas han sido modificadas manualmente",
        totals: {
            title: "Totales",
            efectiu: "Efectivo",
            targeta: "Tarjeta",
            operacions: "Operaciones",
            total: "Total",
        },
        linies: {
            title: 'Líneas de operación',
            create: 'Crear línea de operación',
            update: 'Modificar línea de operación',
            view: 'Línea de operación',
            totals: {
				preuMig : 'Precio medio',
				totalQuantitat: 'Cantidad total'
			},
            liniesArticle: {
                title: 'Líneas de artículo',
                create: 'Crear líneas de artículo',
                update: 'Modificar líneas de artículo',
            },
        },
        action: {
            campAbonament: 'Cantidad a reembolsar',
            campPreuAbonament: 'Precio por cantidad a reembolsar',
            tooltipCampAbonament: 'Índica la cantidad de artículos que quieres reembolsar',
            tooltipCampPreuAbonament: 'Índica el precio individual de cada cantidad que quieres reembolsar',
            seleccionarTot: 'Seleccionar todas las operaciones',
        },
    },
    opcions: {
        title: 'Opciones',
        create: 'Crear una opción',
        update: 'Modificar una opción',
    },
    articlesOpcions: {
        title: 'Artículos / opciones',
        create: 'Crear artículo / opción',
        update: 'Modificar artículo / opción',
        opcioSeleccionada: 'Artículos seleccionables para la opción',
        tooltipTancarOpcio: 'Cerrar opción seleccionada',
    },
    consumTripulacio: {
        title: 'Consumo de tripulación',
        create: 'Crear consumo de tripulación',
        update: 'Modificar consumo de tripulación',
        readOnly: 'Detalle de consumo de tripulación',
        totals: {
            title: "Totales",
            efectiu: "Efectivo",
            targeta: "Tarjeta",
            operacions: "Operaciones",
            total: "Total",
        },
    },
    talonaris: {
        title: 'Talonarios',
        create: 'Crear talonario',
        update: 'Modificar talonario',
    },
    bonosTalonari: {
        title: 'Bonos de talonarios',
        create: 'Crear bono de talonario',
        update: 'Modificar bono de talonario',
        tooltipModificarEstat: 'Filtrar por tipo afiliado y selecciona registros para poder ejecutar la acción de modificar estado',
        anarTalonari: 'Ver talonario',
    },
    controlFotografia: {
        title: 'Control de fotografía',
        create: 'Crear control de fotografía',
        update: 'Modificar control de fotografía',
        totals: {
            postalsFetes: 'Postales hechas',
            postalsVenudes: 'Postales vendidas',
            importPostals: 'Importe postales',
            clauersFets: 'Llaveros hechos',
            clauersVenuts: 'Llaveros vendidos',
            importClauers: 'Importe llaveros',
            totalVenut: 'Total vendido',
            totalControlsFotografia: 'Total control de fotografía',
            importTargeta: 'Importe tarjeta',
            importEfectiu: 'Importe efectivo',
            importTotal: 'Importe total',
        },
    },
};

export default translationEs;
